<template>
  <van-row class="rank-item">
    <van-col class="ranking" :span="spans[0]">
      <template v-if="isOnRank">
        <van-image
          :src="[goldIcon, silverIcon, bronzeIcon][rank - 1]"
          :width="transPxToRem(32)"
          :height="transPxToRem(32)"
          v-if="[1, 2, 3].includes(rank)"
        />
        <span v-else>NO.{{ rank }}</span>
      </template>
      <span v-else>未上榜</span>
    </van-col>
    <van-col class="rank-person" :span="spans[1]">
      <van-image round :width="transPxToRem(32)" :height="transPxToRem(32)" :src="agentInfo.avatarUrl" />
      <div class="name-agent">
        <div class="name-text van-ellipsis">{{ agentInfo.nickname }}</div>
        <div class="agent-text">{{ agentInfo.levelName }}</div>
      </div>
    </van-col>
    <van-col :span="spans[2]" class="earnings" :style="{ textAlign: diffValue ? 'right' : 'center' }">
      <div>
        {{ formateTypeValue(typeValue) }}
      </div>
      <div class="des-text" v-if="Number(rank) !== 1 && showPlace === 'bottom'">
        距上{{ isOnRank ? '一名' : '榜' }}差：{{ diffValue }}
      </div>
    </van-col>
  </van-row>
</template>
<script setup>
import { transPxToRem } from '@/utils'
import { RankTypeEnum } from '../agentRank.data'
import goldIcon from '@/assets/img/gold_medal.png'
import silverIcon from '@/assets/img/silver_medal.png'
import bronzeIcon from '@/assets/img/bronze_medal.png'
const props = defineProps({
  rankType: Number,
  rank: Number,
  isOnRank: Number,
  typeValue: String,
  diffValue: String,
  agentInfo: {
    type: Object,
    default: () => ({})
  },
  spans: {
    type: Array,
    default: () => [6, 12, 6]
  },
  showPlace: {
    type: String,
    default: 'list'
  }
})
const formateTypeValue = val => {
  return [RankTypeEnum.SALES_AMOUNT, RankTypeEnum.EARNINGS, RankTypeEnum.PERSONAGE_RESULT].includes(props.rankType)
    ? '¥' + val
    : val
}
</script>
<style lang="less" scoped>
.rank-item {
  text-align: center;
  .ranking {
    text-align: left;
    display: flex;
    align-items: center;
    color: #666;
  }
  .rank-person {
    display: flex;
    align-items: center;
    .name-agent {
      margin-left: 8px;
      text-align: left;
      .name-text {
        max-width: 120px;
      }
      .agent-text {
        font-size: 12px;
        color: var(--van-black-9);
      }
    }
  }
  .earnings {
    font-weight: 500;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    .des-text {
      font-size: 12px;
      font-weight: 400;
      color: var(--van-black-9);
    }
  }
}
</style>
